module.exports = __webpack_public_path__ + "imgs/logo-full.a39565678ef661d9865a9843f0f0a087.svg";